// extracted by mini-css-extract-plugin
export default {"table-container":"GroupedResales_table-container__213TG","row-border":"GroupedResales_row-border__3fWyM"};